module.exports = __webpack_public_path__ + "static/0017-37ec0cdb69fb5efc3f17de5f8310c88d.png";